import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  .banner-image-block {
    position: relative;
    overflow: hidden;

    a {
      display: block;
    }

    .title-banner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      .text-title-banner {
        color: ${theme.white};
        letter-spacing: 1.65px;
        text-align: center;
      }
    }

    .image {
      position: relative;
      aspect-ratio: 4322 / 1412;
      width: 100%;

      picture,
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .swiper-pagination-bullets {
      bottom: 45px;
    }
  }

  .search-block {
    .search-block-content {
      position: relative;
      margin-top: -30px;
      z-index: 2;
      padding: 0 18%;
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .search-block {
      .search-block-content {
        padding: 0 12%;
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .banner-image-block {
      border-radius: 0;

      .image {
        &.has-mobile-image {
          aspect-ratio: unset;
          height: 300px;
        }
      }

      .swiper-pagination-bullets {
        bottom: 0px;
      }
    }

    /* .search-block {
      .search-block-content {
        padding: 12px 10px;
        border-radius: 20px;
        box-shadow: 0 20px 30px 0 rgba(178, 106, 106, 0.16);
        background-color: #eae7e4;
        margin-top: 10px;
      }

      &.desktop {
        display: none;
      }
      &.mobile {
        display: block;
        .title-banner {
          margin-bottom: 15px;
          .text-title-banner {
            text-align: center;
            color: ${theme.darkRed};
          }
        }
      }
    } */
  }
`
